import { Trans, useTranslation } from 'react-i18next'

import { refundMethods } from '@reveni-io/reveni-ui'

import { getTextForWhenIssueRefund } from '@/helpers'

import { getFormattedAmount } from '../helpers'
import InstantReveniHeader from '../InstantReveniHeader/InstantReveniHeader'
import { Container } from './styles'

const GiftCardMessage = ({
  amount,
  amountInStoreCurrency,
  storeName,
  instant,
  currency = 'EUR',
  storeCurrency = 'EUR',
  issueRefundAtStatus,
  isCancellationsPortal,
}) => {
  const { t, i18n } = useTranslation()
  const amountFormatted = getFormattedAmount({
    currency,
    storeCurrency,
    amount,
    amountInStoreCurrency,
    language: i18n.language,
  })
  const textForWhenIssueRefund = getTextForWhenIssueRefund(t, issueRefundAtStatus)

  if (isCancellationsPortal) {
    return (
      <Container>
        <p>{t('Tarjeta regalo')}</p>
        <p>
          <Trans i18nKey="giftCardCancellationsPortalMessage" values={{ amount: amountFormatted, storeName }} />
        </p>
      </Container>
    )
  }

  return (
    <Container>
      {instant ? (
        <>
          <InstantReveniHeader type={refundMethods.giftCard} />
          <p>
            <Trans i18nKey="giftCardInstantMessage" values={{ amount: amountFormatted, storeName }} />
          </p>
        </>
      ) : (
        <>
          <p>{t('Tarjeta regalo')}</p>
          <p>
            <Trans
              i18nKey="giftCardNormalMessage"
              values={{ amount: amountFormatted, textForWhenIssueRefund, storeName }}
            />
          </p>
        </>
      )}
    </Container>
  )
}

export default GiftCardMessage
